import React, { Component, Dispatch } from 'react';
import Translator from '../../../core/i18n';
import { Log, Level, Logger, Display } from 'ng2-logger';
import CCourseContentContainer from '../containers/course-contents-container/container';
import StudentListUpdated from '../student-list/main';
import Processes from '../processes/main';
import CourseFiles from '../course-files/main';
import { IlessonTabMenu, TabMenuItems } from '../../../models/components/lesson-menu-tab';
import { IAppState, IAction } from '../../../models/action/core';
import * as Actions from '../../../store/actions/coursePage';
import { connect } from 'react-redux';
import MainForum from '../../../pages/forum/main';
import MainAnnouncement from '../../../pages/announcement/main';
import { setForumMessageDefault } from '../../../store/actions/forum';

import { Link, Redirect } from 'react-router-dom';
const searchParams = new URLSearchParams();

const T = Translator.create();
const _logger = Log.create('LessonPageTabMenu');

class LessonPageTabMenu extends React.Component<IlessonTabMenu> {
    public state = {
        activeTabType: TabMenuItems,
        redirect: false,
    };
    constructor(props: any) {
        super(props);
    }

    public componentDidMount = () => {
        this.setActiveTab();
    };

    public componentWillReceiveProps = (nextProps: IlessonTabMenu, prevProps: IlessonTabMenu) => {
        this.setActiveTab();
    };

    public setActiveTab = () => {

        const getTabElementId = document.getElementsByClassName('nav-link');
        // tslint:disable-next-line:prefer-for-of
        for (let index = 0; index < getTabElementId.length; index++) {
            if (getTabElementId[index].getAttribute('data-tabparam') === this.props.homePageSelectedTab) {
                getTabElementId[index].classList.add('active');
            }
        }
    };

    public componentDidUpdate = (nextProps: IlessonTabMenu) => {
        const getTabElementId = document.getElementsByClassName('nav-link');
        // tslint:disable-next-line:prefer-for-of
        for (let index = 0; index < getTabElementId.length; index++) {
            if (getTabElementId[index].getAttribute('data-tabparam') === this.props.homePageSelectedTab) {
                getTabElementId[index].classList.add('active');
                this.handleChangeTab(this.props.homePageSelectedTab)
            } else {
                getTabElementId[index].classList.remove('active');
            }
        }
    };

    handleChangeTab = (tabname: string) => {
        if (window.location.search) {
            const params = new URLSearchParams(window.location.search);
            const activeTab = params.get('type');
            
            if(tabname !== activeTab){

                params.set('type', tabname);
                const newUrl = `${window.location.pathname}?${params.toString()}`;
                window.history.pushState(null, '', newUrl);
            }
        }
    }

    public tabOnClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
        if (event) {
            const getMenuParam = event.currentTarget.dataset.tabparam;
            this.props.dispatch(Actions.getCoursePageSelectedTab(getMenuParam ?? '1'));
            this.setState(() => ({ activeTabType: getMenuParam, redirect: true }));
            if (getMenuParam === TabMenuItems.discussion.toString()) {
                this.props.dispatch(setForumMessageDefault());
            }
        }
    };

    public render() {
        let coursePage: any;
        if(this.props){
            if(this.props.homePageSelectedTab === TabMenuItems.courseContent.toString()){
                coursePage = <CCourseContentContainer /> ;
            } else if(this.props.homePageSelectedTab === TabMenuItems.studentList.toString()){
                coursePage = <StudentListUpdated /> ;
            } else if(this.props.homePageSelectedTab === TabMenuItems.files.toString()){
                coursePage = <CourseFiles />;
            } else if(this.props.homePageSelectedTab === TabMenuItems.discussion.toString()){
                coursePage = <MainForum classId={this.props.coursePageClassId!} /> ;
            } else if(this.props.homePageSelectedTab === TabMenuItems.processes.toString()){
                coursePage = <Processes courseId={this.props.coursePageActivityId} classId={this.props.coursePageClassId!} copyResultData={null} /> ; 
            } else if(this.props.homePageSelectedTab === TabMenuItems.announcements.toString()){
                coursePage = <MainAnnouncement classId={this.props.coursePageClassId} courseId={this.props.coursePageActivityId} />
            }
        }
        else{
            coursePage = 'Kayıt Yok ';
        }

        return (
            <div>
                {coursePage}

                {this.state.redirect ? (
                    <Redirect
                        to={
                            '/almsp/u/course?classId=' +
                            this.props.coursePageClassId +
                            '&activityId=' +
                            this.props.coursePageActivityId +
                            '&type=' +
                            this.state.activeTabType
                        }
                    />
                ) : (
                    ''
                )}
                {(this.state.redirect = false)}
            </div>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: IlessonTabMenu): IlessonTabMenu => {
    if (!state) {
        return ownProps;
    }
    const newProps: IlessonTabMenu = Object.assign({}, ownProps, {
        homePageSelectedTab: state.coursePage.homePageSelectedTab,
        coursePageClassId: state.coursePage.coursePageClassId,
        coursePageActivityId: state.coursePage.coursePageActivityId
    });
    return newProps;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch,
    };
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret = (
        next.coursePage.homePageSelectedTab === prev.coursePage.homePageSelectedTab &&
        next.coursePage.coursePageClassId === prev.coursePage.coursePageClassId
    );
    return ret;
};

const CLessonPageTabMenu = connect(
    mapStateToProps,
    dispatchProps,
    null,
    {
        areStatesEqual,
    }
)(LessonPageTabMenu);

export default CLessonPageTabMenu;
